import React, { useCallback, useMemo } from 'react'

import ButtonSelector from '../ButtonSelector'

import { defaultTrackTargets } from '../../../models/types.ClientDTO'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'

import './TrackTargetSelector.scss'

const CLASS = 'insights-portal-track-target-selector'

type ValueType = { trackTarget: 'attribute' | 'entity' }
type TrackTargetSelectorProps = {
  className?: string
  trackTarget?: 'attribute' | 'entity'
  onTrackTargetChange?: (value: ValueType) => void
}

export const TrackTargetSelector: React.FC<TrackTargetSelectorProps> = ({
  className: propsClassName,
  trackTarget: propsTrackTarget = 'entity',
  onTrackTargetChange: propsOnTrackTargetChange
}) => {
  const className = propsClassName || CLASS

  const trackTarget = propsTrackTarget || 'entity'

  const track = defaultTrackTargets[trackTarget]?.track

  const trackTargetOptions = useMemo(
    () =>
      Object.entries(defaultTrackTargets).map(
        ([key, value]) =>
          ({ code: key, name: decode(value.track) }) as { code: keyof typeof defaultTrackTargets; name: string }
      ),

    []
  )

  const onTrackTargetChange = useCallback(
    (event: { value: (typeof trackTargetOptions)[number] }) => {
      if (propsOnTrackTargetChange && event.value.code !== trackTarget) {
        propsOnTrackTargetChange({ trackTarget: event.value.code })
      }
    },
    [propsOnTrackTargetChange, trackTarget]
  )

  return (
    <ButtonSelector
      className={className}
      options={trackTargetOptions}
      label={decode(track)}
      onChange={onTrackTargetChange}
    />
  )
}

TrackTargetSelector.displayName = 'TrackTargetSelector'
